export default __webpack_public_path__ + "static/spett0-5aa8e211488ae1a548c4852158a78097.png";